import { configureStore } from '@reduxjs/toolkit';

import navigationBarSlice from '../../slices/navigationBarSlice';

const store = configureStore({
  reducer: {
    navigationBar: navigationBarSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
